import React from 'react';
import ReactDOM from 'react-dom';
import './Assets/Css/index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import $ from 'jquery';
import Popper from 'popper.js';
import TagManager from 'react-gtm-module'


/*const tagManagerArgs = {
    gtmId: 'AW-10795233028'
}
 
TagManager.initialize(tagManagerArgs)*/


ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
